import HTTPService from "../utility/httpService";
import { keyConstants, apiEndPointConstants } from "../constants";
import Utils from "../utility";
const { TOKEN } = keyConstants;
const { CONSENT, CONSENT_LIST_BY_ID } = apiEndPointConstants;

export default class UserService {
  /**
   * Initializes a new instance of the class.
   *
   * @constructor
   */
  constructor(token) {
    this.httpService = new HTTPService(
      process.env.REACT_APP_CONSENT_MICROSERVICE
    );
    this.config = {
      headers: {
        Authorization: `Bearer ${
          token !== undefined ? token : Utils.cookieGetItem(TOKEN)?.access_token
        }`,
        "X-Api-Key": process.env.REACT_APP_X_API_KEY
      }
    };
  }

  /**
   * Retrieves consent based on business ID.
   *
   * @param {number} businessId - The ID of the business.
   * @return {Promise} A promise that resolves with the consent data.
   */
  getConsentList(businessId) {
    const url = `${CONSENT_LIST_BY_ID}/${businessId}`;
    const requestData = {};

    return this.httpService.get(url, requestData, this.config);
  }

  /**
   * Uploads a file.
   *
   * @param {FormData} formData - The form data containing the file to upload.
   * @return {Observable<Response>} - An observable that emits the response from the server.
   */
  fileUpload(formData) {
    return this.httpService.post(CONSENT, formData, this.config);
  }

  uploadFile(requestData) {
    const url = `${CONSENT}`;
    return this.httpService
      .post(url, requestData, this.config)
      .catch((error) => {
        throw error instanceof Error ? error.message : "Upload file failed";
      });
  }
}
